<app-navbar></app-navbar>
<div class="inicio text-center d-none d-lg-block d-xl-block">
    <br><br>
    <h3><img src="../../../assets/img/login.png" class="img-fluid" alt=""><br> Ingreso al Sistema SuPedido</h3>
    <br>
    <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
        <div class="form-group">
            <input class="lgn" type="mail" placeholder="Ingrese su correo electrónico" formControlName="email" [class.is-invalid]="emailNoValido">
            <br>
            <small class="eml" *ngIf="emailNoValido">Ingrese un correo válido</small>
        </div>
        <div *ngIf="!pass" class="form-group">
            <input class="lgnPss" type="password" placeholder="Ingrese su contraseña" formControlName="password" [class.is-invalid]="passwordNoValido"><button (click)="activarPass()" class="eye"><i class="fa fa-eye-slash"></i></button>
            <br>
            <small class="spn" *ngIf="passwordNoValido">La contraseña debe ser de 8 caracteres mínimo.</small>
        </div>
        <div *ngIf="pass" class="form-group">
            <input class="lgnPss" type="text" placeholder="Ingrese su password" formControlName="password" [class.is-invalid]="passwordNoValido"><button (click)="desactivarPass()" class="eye"><i class="fa fa-eye"></i></button>
            <br>
            <small class="spn" *ngIf="passwordNoValido">La contraseña debe ser de 8 caracteres mínimo.</small>
        </div>
        <button type="submit" class="btnLgn">Ingresar</button>
    </form>

    <div class="col-12 mt-2 text-center">
        <h5 style="color: #2f5496;cursor: pointer;" (click)="contrasena()" data-dismiss="modal">¿Olvidaste tu Contraseña?</h5>
    </div>
    <button class="btnLgn2" data-toggle="modal" data-target="#registro">Crear Cuenta</button>
</div>
<div class="inicio d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
    <div class="container">
        <br><br>
        <div class="text-center">
            <h5><img src="../../../assets/img/login.png" class="img-fluid" alt=""><br> Ingreso al Sistema SuPedido</h5>
        </div>
        <br>
        <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
            <div class="form-group">
                <input class="lgnMovil" type="mail" placeholder="Ingrese su correo electrónico" formControlName="email" [class.is-invalid]="emailNoValido">
                <br>
                <small class="eml" *ngIf="emailNoValido">Ingrese un correo válido</small>
            </div>
            <div *ngIf="!pass" class="form-group">
                <input class="lgnPssMovil" type="password" placeholder="Ingrese su contraseña" formControlName="password" [class.is-invalid]="passwordNoValido"><button (click)="activarPass()" class="eye"><i class="fa fa-eye-slash"></i></button>
                <br>
                <small class="spnMovil" *ngIf="passwordNoValido">La contraseña debe ser de 8 caracteres mínimo.</small>
            </div>
            <div *ngIf="pass" class="form-group">
                <input class="lgnPssMovil" type="text" placeholder="Ingrese su password" formControlName="password" [class.is-invalid]="passwordNoValido"><button (click)="desactivarPass()" class="eye"><i class="fa fa-eye"></i></button>
                <br>
                <small class="spnMovil" *ngIf="passwordNoValido">La contraseña debe ser de 8 caracteres mínimo.</small>
            </div>
            <button type="submit" class="btnLgnMovil">Ingresar</button>
        </form>

        <div class="col-12 mt-2 text-center">
            <h5 style="color: #2f5496;cursor: pointer;" (click)="contrasena()" data-dismiss="modal">¿Olvidaste tu Contraseña?</h5>
        </div>
        <button class="btnLgn2Movil" data-toggle="modal" data-target="#registro">Crear Cuenta</button>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="registro" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Registro en Sistema</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <h3>Por favor seleccione el tipo de registro:</h3>
                <hr>
                <div class="text-center d-none d-lg-block d-xl-block">
                    <button class="rgtr" (click)="registrar('Distribuidor')" data-dismiss="modal"><img src="../../../assets/img/distribuidor.png" class="img-fluid" width="70" alt=""><br> <b style="font-size: 19px;">QUIERO DISTRIBUIR</b></button>
                    <button class="rgtr ml-4" (click)="registrar('Comprador')" data-dismiss="modal"><img src="../../../assets/img/comprador.png" class="img-fluid" width="70" alt=""><br><b style="font-size: 19px;">QUIERO COMPRAR</b></button>
                </div>
                <div class="text-center d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-6">
                                <button class="rgtrMovil" (click)="registrar('Distribuidor')" data-dismiss="modal"><img src="../../../assets/img/distribuidor.png" class="img-fluid" width="70" alt=""><br> <b style="font-size: 19px;">QUIERO DISTRIBUIR</b></button>
                            </div>
                            <div class="col-6">
                                <button class="rgtrMovil" (click)="registrar('Comprador')" data-dismiss="modal"><img src="../../../assets/img/comprador.png" class="img-fluid" width="70" alt=""><br><b style="font-size: 19px;">QUIERO COMPRAR</b></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>